import * as React from 'react'
import { Container } from './Container'
import geometricM from './images/geometric-m-blue.png'
import geometricNotM from './images/geometric-not-m-blue.png'
import styles from './styles.module.scss'

import Image from 'next/image'
import clsx from 'clsx'
import { LocationIcon } from './LocationIcon'
import Script from 'next/script'

export function Registration() {
  return (
    <div className="bg-[#4D2781] relative">
      <Image
        src={geometricM}
        alt=""
        unoptimized
        className="absolute left-0 bottom-0"
      />
      <Image
        src={geometricNotM}
        alt=""
        unoptimized
        className="absolute top-0 right-0"
      />
      <Container className="relative py-14 lg:py-28 grid grid-cols-1 items-center">
        <div>
          <h2
            className={clsx(
              'text-white font-body lg:sm:text-5xl text-4xl font-bold mb-7',
            )}>
            Ready to navigate the next wave of tech and innovation?
          </h2>
          <p className="text-white text-xl mb-10 md:mb-20">
            Reserve your spot at the MarketX Ventures 2023 Technology &
            Innovation Summit today.
          </p>
          <div className="flex gap-7 items-center">
            <LocationIcon />
            <p className="text-[#96FFE5] text-2xl max-w-md leading-relaxed">
              Our summit will be held at <strong>Shack15</strong> in the heart
              of <strong>San Francisco</strong>.
            </p>
          </div>
        </div>
        <div className="">
          <h2 className="text-white font-body text-5xl font-bold mt-20">
            Register
          </h2>
        </div>
        <div>
          <Script src="https://js.tito.io/v2" async></Script>
          {/* @ts-ignore */}
          <tito-widget event="marketx-ventures/technology-innovation-summit"></tito-widget>
        </div>
      </Container>
    </div>
  )
}
